// legacy for getting rid of pre cockroach stuff.
const onlyCockroach = 'op: ">=", value: "300000000"';
const minHeight = 81;

export default {
  filmFileDownloadDetail:`
    fragment filmFileDownloadDetail on FilmFileDownload {
      expires
      downloadLink
      mimeType
      patchedLink
    }
  `,


  bestDownloadFilmFileDetail: `
    fragment bestDownloadFilmFileDetail on FilmFile {
      ...filmFileDetail
      FilmFileDownload {
        ...filmFileDownloadDetail
      }
    }
  `,

  filmFileArtifactDetail: `
    fragment storageArtifactDetail on StorageArtifact {
      SignedUrl {
        url
        expires
      }
      name
      size
      contentType
    }
  `,

  provokeCallsheetAnalysisDetail: `
    fragment provokeCallsheetAnalysisDetail on ProvokeCallsheetAnalysis {
      id
      runID
      mode
      workType
    }
  `,

  kgraphDetail: `
    fragment kgraphDetail on Kgraph {
      id
      wiki
      articleBody
      license
      types
      url
      imageUrl
      imageContentUrl
      name
    }
  `,
  callsheetAnalysisDetail: `
    fragment callsheetAnalysisDetail on CallsheetAnalysis {
      id
      callsheetID
      type
      personID
      Person {
        ...personDetail
        searchName
        ...personArtworks
      }
      professionID
      Profession {
        ...profession
      }
      contactID
      Contact {
        ...contactDetail
      }
      companyID
      Company {
        ...companyDetail
      }
      runID
      person
      profession
      phone
      mobile
      email
      company
      kgMid
      Kgraph {
        ...kgraphDetail
      }
    }
  `,

  callsheetAnalysisProgressDetail: `
    fragment callsheetAnalysisProgressDetail on CallsheetAnalysisProgress {
  			id
        status
        error
        success
        runID
    }
  `,

  artworkArtifact: `
    fragment artworkArtifact on ArtworkToFile {
      ArtworkArtifact {
        SignedUrl {
          url
          expires
        }
        SignedUrlDownload {
          expires
          url
          saveAs
        }
      }
    }
  `,

  callsheetDetail: `
    fragment callsheetDetail on Callsheet {
      id
      comment
      originalName
      runID
      callsheetMetadata {
        region
        country
        type
        companyType
        companyName
        personName
        brandName
        filmMasterOrigin
        variant
      }
      Artwork {
        id
        ArtworkToFiles {
          ...artworkDetails
          ...artworkArtifact
        }
      }
    }
  `,
  viLabelProgressDetail: `
    fragment viLabelProgressDetail on ViLabelProgress {
      id
      runID
      status
      error
      success
    }
  `,

  viLabelProps: `
    fragment viLabelProps on ViLabel {
      id
      type
      itemOrder
      description
      entityID
      speakerTag
      entityID
      segments {
        startTime
        endTime
        confidence
      }
    }
  `,

  objectTrackingProps: `
    fragment objectTrackingProps on ViLabel {
      objectTracking {
        slotStart
        slotEnd
        shotIndex
        left
        right
        top
        bottom
      }
    }
  `,

  slimLabelDetail: `
    fragment slimLabelDetail on ViLabel {
      ...viLabelProps
      ...objectTrackingProps
    }
  `,

  viLabelDetail: `
    fragment viLabelDetail on ViLabel {
      ...viLabelProps
      Kgraph {
        ...kgraphDetail
      }
    }
  `,

  vimeoIDMatchDetail: `
    fragment vimeoIDMatchDetail on FilmMaster {
      ...filmMasterDetail
      Film {
        ...filmDetail
      }
    }
  `,

  md5MatchDetail: `
    fragment md5MatchDetail on FilmFile {
      ...filmFileDetail
      FilmMaster {
        ...filmMasterDetail
        Film {
          ...filmDetail
        }
      }
    }
  `,
  vimeoFileDetail: `
    fragment vimeoFileDetail on VimeoFile {
      quality
      type
      width
      height
      link
      created_time
      fps
      size
      md5
    }
  `,
  vimeoVideoDetail: `
    fragment vimeoVideoDetail on VimeoVideoInfo {
      id
      uri
      name
      description
      type
      link
      duration
      height
      width
      language
      created_time
      modified_time
      release_time
      content_rating
      license
      tags
      status
      resource_key
    }
  `,
  vimeoPrivacyDetail: `
    fragment vimeoPrivacyDetail on VimeoPrivacy {
        view
        comments
        embed
        download
        add
    }
  `,
  vimeoPictureDetail: `
    fragment vimeoPictureDetail on VimeoPicture {
      uri
      active
      type
      sizes {
        width
        height
        link
      }
    }
  `,
  vimeoMetadataDetail: `
    fragment vimeoMetadataDetail on VimeoMetadataItem {
      uri
      options
      total
    }
  `,
  vimeoUserDetail: `
    fragment vimeoUserDetail on VimeoUserInfo {
      id
      uri
      name
      link
      location
      bio
      created_time
      account
    }
  `,
  vimeoWebsiteDetail: `
    fragment vimeoWebsiteDetail on VimeoWebsite {
      name
      link
      description
    }
  `,

  profSearcherResult: `
    fragment profSearcherResult on SearcherResult {
      totalRows
      aggregations
      Searchers {
        ...profSearchers
      }
    }
  `,

  comSearcherResult: `
    fragment comSearcherResult on SearcherResult {
      totalRows
      aggregations
      Searchers {
        ...comSearchers
      }
    }
  `,
  searcherResult: `
    fragment searcherResult on SearcherResult {
      totalRows
      Searchers {
        ...searchers
      }
    }
  `,
  userProfileBig: `
    fragment userProfileBig on User {
      ...userProfileDetail
      Person {
        ...personDetail
        ...personArtworks
      }
      Company {
        ...companyDetail
        ...companyArtworks
      }
    }
  `,
  whoAmI: `
    fragment whoAmI on WhoAmI {
      userID
      User {
        ...userDetails
      }
    }
  `,
  userDetails: `
    fragment userDetails on User {
      id
      personID
    }
  `,

  contactDetail: `
    fragment contactDetail on Contact {
      id
      personID
      Person {
        ...personDetail
      }
    }
  `,

  userProfileDetail: `
    fragment userProfileDetail on User {
      id
      contactEmail
      personID
      contactEmailPrivate
      personID
      companyID
      personalAssistantInformation
      vimeoID
    }
  `,

  matchDetail: `
    fragment matchDetail on MatchDetail {
      match
      highlight
      key
      confidence
      labelType
    }
  `,

  profMatchDetail: `
    fragment profMatchDetail on MatchDetail {
      match
      highlight
      key
    }
  `,

  comMatchDetail: `
    fragment comMatchDetail on MatchDetail {
      match
      highlight
      key
    }
  `,

  searchers: `
    fragment searchers on Searcher {
      ...searchItems
      score
      MatchReasons {
        ...matchReason
      }
    }
  `,

  profSearchers: `
    fragment profSearchers on Searcher {
      ...searchItems
      score
      MatchReasons {
        ...profMatchReason
      }
    }
  `,

  comSearchers: `
    fragment comSearchers on Searcher {
      ...searchItems
      score
      MatchReasons {
        ...comMatchReason
      }
    }
  `,

  searchItems: `
    fragment searchItems on Searcher {
      itemType
      itemID
      itemName
      source
    }
  `,

  matchReason: `
    fragment matchReason on MatchReason {
      match
      matchType
      matchID
      MatchDetails {
        ...matchDetail
      }
      ...matchIDS
      ...matchFilm
      ...matchPerson
      ...matchBrand
      ...matchProduct
      ...matchCompany
      ...matchAward
      ProfessionMatchItems {
        ...matchProfession
      }
      CompanyTypeMatchItems {
        ...matchCompanyType
      }
    }
  `,

  profMatchReason: `
    fragment profMatchReason on MatchReason {
      match
      matchType
      matchID
      MatchDetails {
        ...profMatchDetail
      }
      professionID
      Profession {
        ...profession
      }
    }
  `,

  comMatchReason: `
    fragment comMatchReason on MatchReason {
      match
      matchType
      matchID
      MatchDetails {
        ...comMatchDetail
      }
      companyID
      Company {
        id
      }
    }
  `,

  matchIDS: `
    fragment matchIDS on MatchReason {
      personID
      companyID
      filmID
      brandID
      productID
      awardID
      professionID
    }
  `,
  matchFilm: `
    fragment matchFilm on MatchReason {
      Film {
        ...filmDetail
        ...filmMasters
        ...filmAwards
      }
    }
  `,
  personBigAwards: `
    fragment personBigAwards on Person {
      PersonToAwards {
        id
        theYear
        DeepAward: Award {
          id
          itemOrder
          ...awardAncestor
          __typename
        }
        AwardPrize {
          ...awardPrizeDetail
          ...awardPrizeArtworks
        }
      }
    }
  `,
  matchPerson: `
    fragment matchPerson on MatchReason {
      Person {
        ...personDetail
        ...personArtworks
        ...personAwards
      }
    }
  `,
  matchProfession: `
    fragment matchProfession on ProfessionMatchItem {
      Profession {
        ...profession
      }
    }
  `,
  matchBrand: `
    fragment matchBrand on MatchReason {
      Brand {
        ...brandDetail
        ...brandArtworks
      }
    }
  `,
  matchProduct: `
    fragment matchProduct on MatchReason {
      Product {
        ...productDetail
        ...productArtworks
      }
    }
  `,
  matchCompany: `
    fragment matchCompany on MatchReason {
      Company {
        ...companyDetail
        ...companyArtworks
      }
    }
  `,
  matchCompanyType: `
    fragment matchCompanyType on CompanyTypeMatchItem {
      CompanyType {
        ...companyTypeTree
      }
    }
  `,
  awardFilms: `
    fragment awardFilms on Award {
      ViewAwardFilms {
        filmID
        Film {
          ...filmDetail
          ...filmMasters
          ...filmBigAwards
        }
        AwardPrizeMatchItems {
          ...awardPrizeSim
        }
      }
    }
  `,
  awardPeople: `
    fragment awardPeople on Award {
      ViewAwardPeople {
        personID
        Person {
          ...personBigAwards
          ...personDetail
          ...personArtworks
        }
        AwardPrizeMatchItems {
          ...awardPrizeSim
        }
      }
    }
  `,
  awardPrizeSim: `
    fragment awardPrizeSim on AwardPrizeMatchItem {
      theYear
      deepAwardID
      awardID
      AwardAncestors {
        id
        name
      }
      AwardPrize {
        ...awardPrizeDetail
        ...awardPrizeArtworks
      }
    }
  `,
  awardAncestor: `
    fragment awardAncestor on Award {
      ViewAwardAncestor {
        id
        AwardAncestors {
          id
          name
        }
      }
    }
  `,
  matchAward: `
    fragment matchAward on MatchReason {
      AwardPrizeMatchItems {
        theYear
        AwardPrize {
          ...awardPrizeDetail
          ...awardPrizeArtworks
        }
        DeepAward {
          id
          ... awardAncestor
        }
      }
      Award {
        ...awardDetail
      }
    }
  `,
  awardPrizeArtworks: `
    fragment awardPrizeArtworks on AwardPrize {
      AwardPrizeToArtworks {
        id
        Artwork {
          id
          ...artworkToArtifacts
        }
      }
    }
  `,
  filmBigAwards: `
    fragment filmBigAwards on Film {
      FilmToAwards {
        id
        theYear
        DeepAward: Award {
          id
          itemOrder
          ...awardAncestor
        }
        AwardPrize {
          ...awardPrizeDetail
          ...awardPrizeArtworks
        }
      }
    }
  `,
  filmAwards: `
    fragment filmAwards on Film {
      FilmToAwards {
        Award {
          ...awardDetail
        }
        AwardPrize {
          ...awardPrizeDetail
          ...awardPrizeArtworks
        }
      }
    }
  `,
  awardPrizeDetail: `
    fragment awardPrizeDetail on AwardPrize {
      id
      itemOrder
      AwardPrizeLocalized {
        id
        name
      }
    }
  `,
  awardDeep: `
    fragment awardDeep on Award {
      id
      itemOrder
      ...awardAncestor
    }
  `,
  awardDetail: `
    fragment awardDetail on Award {
      id
      itemOrder
      AwardLocalized {
        id
        name
      }
    }
  `,
  brandDetail: `
    fragment brandDetail on Brand {
      id
      name
      strategy
      url
    }
  `,
  productDetail: `
    fragment productDetail on Product {
      id
      name
      url
      productCategoryID
      ProductCategory {
        ...productCategoryTree
      }
    }
  `,
  productCategory: `
    fragment productCategory on ProductCategory {
      id
      ProductCategoryLocalized {
        id
        name
      }
    }
  `,
  productCategoryTree: `
    fragment productCategoryTree on ProductCategory {
      ...productCategory
      Parent {
        ...productCategory
        Parent {
          ...productCategory
          Parent {
            ...productCategory
          }
        }
      }
    }
  `,
  personAwards: `
    fragment personAwards on Person {
      PersonToAwards {
        Award {
          ...awardDetail
        }
        AwardPrize {
          ...awardPrizeDetail
          ...awardPrizeArtworks
        }
      }
    }
  `,
  filmDetail: `
    fragment filmDetail on Film {
      id
      filmName
      synopsis
    }
  `,
  filmMasterDetail: `
    fragment filmMasterDetail on FilmMaster {
      id
      embed
      filmID
      ...filmHost
      ...filmMasterPosterFrames
      ...filmFiles
      ...stripDetail
    }
  `,
  stripDetail: `
    fragment stripDetail on FilmMaster {
      stripUrl
      StripArtifact {
        SignedUrl {
          expires
          url
        }
      }
    }
  `,
  filmMasters: `
    fragment filmMasters on Film {
      id
      FilmMasters(limit: $masterLimit, sortFields: "itemOrder", filters:[{
        valueKey: "hostType",
        value: ["vimeo", "gcs"]
      }]) {
        ...filmMasterDetail
      }
    }
  `,

  filmFileDetail: `
    fragment filmFileDetail on FilmFile {
      id
      path
      width
      height
      size
      distributionFormat
      mimeType
      source
      md5
      fps
    }
  `,
  filmFiles: `
    fragment filmFiles on FilmMaster {
      id
      FilmFiles  {
        ...filmFileDetail
        FilmFileArtifact {
          name
          mediaLink
          SignedUrl {
            expires
            url
            name
          }
        }
      }
    }
  `,

  personFilms: `
    fragment personFilms on Person {
      id
      PersonToFilms {
        id
        ...filmRelationships
        Film {
          ...filmDetail
          ...filmMasters
          ...filmBigAwards
        }
        Profession {
          ...profession
        }
      }
    }
  `,

  companyDepartmentDetail:`
    fragment companyDepartmentDetail on CompanyDepartment {
      id
      CompanyDepartmentLocalized {
        name
      }
      CompanyType {
        ...companyTypeTree
      }
    }
  `,

  personCompanies: `
    fragment personCompanies on Person {
      PersonToCompanies {
        id
        Company {
          ...companyDetail
          ...companyArtworks
        }
        Profession {
          ...profession
        }
      }
    }
  `,


  personBigDetail: `
    fragment personBigDetail on Person {
      id
      quote
      interests
      aspiringTo
      education
      comment
      trivia
      contactViaPersonalAssistant
      industryFigure
      publicFigure
      philosophy
      dateDeceased
      deceased
      dateOfBirth
      firstNameInternational
      nickNameInternational
      middleNameInternational
      lastNameInternational
      searchName
      Prefix {
        name
      }
      Suffix {
        name
      }
      PrefixInternational {
        name
        Language {
          name
        }
      }
      SuffixInternational {
        name
        Language {
          name
        }
      }
      Sex {
        SexLocalized {
          name
        }
      }
      Gender {
        GenderLocalised {
          name
        }
      }
      SexualOrientation {
        SexualOrientationLocalised {
          name
        }
      }
      GroupIdentity {
        GroupIdentityLocalised {
          name
        }
      }
      NationalityAtBirth {
        ...locationTree
      }
      Nationality {
        ...locationTree
      }
      PlaceOfBirth {
        ...locationTree
      }
    }
  `,
  filmHost: `
    fragment filmHost on FilmMaster {
      hostID
      hostType
      duration
      hostUserName
      runID
      provenance {
        region
        country
        type
        companyType
        companyName
        personName
        brandName
        filmMasterOrigin
        variant
        title
      }
    }
  `,
  filmMasterPosterFrames: `
    fragment filmMasterPosterFrames on FilmMaster {
      FilmMasterPosterFrames {
        frameNumber
        defaultPosterFrame
        itemOrder
        posterFrameOrder
        storyFrameOrder
        artworkID
        Artwork {
         id
         artworkTypeID
         ArtworkToFiles {
           ...artworkDetails
         }
        }
      }
    }
  `,
  companyNames: `
    fragment companyNames on Company {
      CompanyNames {
        ...companyNameDetail
      }
    }
  `,
  companyDetail: `
    fragment companyDetail on Company {
        ...companyNames
        details
        missionStatement
        experience
        url
        id
    }
  `,
  companyNameDetail: `
    fragment companyNameDetail on CompanyName {
      id
      name
      companyID
    }
  `,
  companyTypeTree: `
    fragment companyTypeTree on CompanyType {
      ...companyType
      Parent {
        ...companyType
        Parent {
          ...companyType
          Parent {
            ...companyType
          }
        }
      }
    }
  `,
  companyType: `
    fragment companyType on CompanyType {
      id
      itemOrder
      CompanyTypeLocalized {
        id
        name
      }
    }
  `,
  companyArtworks: `
    fragment companyArtworks on Company {
      CompanyToArtworks {
        id
        Artwork {
          id
          ...artworkToArtifacts
        }
      }
    }
  `,
  companyPeople: `
    fragment companyPeople on Company {
      CompanyToPeople {
        id
        Person {
          ...personBigAwards
          ...personDetail
          ...personArtworks
        }
        Profession {
          ...profession
        }
      }
    }
  `,
  companyFilms: `
    fragment companyFilms on Company {
      CompanyToFilms {
        id
        Film {
          ...filmDetail
          ...filmMasters
          ...filmBigAwards
        }
      }
    }
  `,
  companyProducts: `
    fragment companyProducts on Company {
      CompanyToProducts {
        id
        Product {
          ...productDetail
          ...productArtworks
        }
        CompanyToProductRelationshipType {
          RelationshipType {
            ...relationshipTypeDetail
          }
        }
      }
    }
  `,
  companyBrands: `
    fragment companyBrands on Company {
      CompanyToBrands {
        id
        Brand {
          ...brandDetail
          ...brandArtworks
        }
        CompanyToBrandRelationshipType {
          RelationshipType {
            ...relationshipTypeDetail
          }
        }
      }
    }
  `,
  companyBigDetail: `
    fragment companyBigDetail on Company {
      foundedDate
      numberOfEmployees
      ceasedTradingDate
      ceasedTrading
      independent
      memberOrganisation
      numberOfMembers
      OperationRegion {
        OperationRegionLocalized {
          name
        }
      }
      CompanyToCompanyTypes {
        CompanyType {
          ...companyTypeTree
        }
      }
    }
  `,
  personDetail: `
    fragment personDetail on Person {
      id
      firstName
      middleName
      lastName
      professionalName
      pseudonym
      philosophy
      biography
    }
  `,
  personArtworks: `
    fragment personArtworks on Person {
      PersonToArtworks(valueKey: "id", ${onlyCockroach})  {
        id
        Artwork {
          id
          ...artworkToArtifacts
        }
      }
    }
  `,
  brandArtworks: `
    fragment brandArtworks on Brand {
        Artwork {
          id
          ...artworkToArtifacts
        }
    }
  `,
  productArtworks: `
    fragment productArtworks on Product {
        Artwork {
          id
          ...artworkToArtifacts
        }
    }
  `,
  artworkDetails: `
    fragment artworkDetails on ArtworkToFile {
      id
      path
      widthPx
      heightPx
      original
      targetName
      imageType
    }
  `,
  artworkToArtifacts: `
    fragment artworkToArtifacts on Artwork {
      id
      ArtworkToFiles (sortFields: "heightPx", op: ">" , value: ${minHeight} , valueKey: "heightPx", limit: 1){
        ...artworkDetails
        ArtworkArtifact {
          SignedUrl {
            url
            expires
          }
        }
      }
    }
  `,
  filmCompanies: `
    fragment filmCompanies on Film {
      FilmToCompanies(limit: 500) {
        Company {
          ...companyDetail
          ...companyArtworks
        }
        CompanyType {
          ...companyTypeTree
        }
      }
    }
  `,
  profession: `
    fragment profession on Profession {
      id
      freelance
      ProfessionLocalized {
        name
      }
      CompanyDepartment {
        ...companyDepartmentDetail
      }
    }
  `,
  filmBrands: `
    fragment filmBrands on Film {
      id
      FilmToBrands {
        Brand {
          ...brandDetail
          ...brandArtworks
        }
      }
    }
  `,
  filmProducts: `
    fragment filmProducts on Film {
      id
      FilmToProducts {
        Product {
          ...productDetail
          ...productArtworks
        }
      }
    }
  `,
  fragRelationshipTypeDetail:`
    fragment fragRelationshipTypeDetail on RelationshipType {
      id: relationshipTypeID
      RelationshipTypeLocalized {
        name
      }
    }
  `,
  filmRelationships: `
    fragment filmRelationships on FilmToPerson {
      cameo
      hidden
      Company {
        id
        ...companyNames
      }
      FilmToPersonRelationshipType {
        RelationshipType {
          ...relationshipTypeDetail
        }
      }
    }
  `,

  filmPeople: `
    fragment filmPeople on Film {
      FilmToPeople(limit: 500) {
        id
        Person {
          ...personBigAwards
          ...personDetail
          ...personArtworks
        }
        Profession {
          ...profession
        }
        ...filmRelationships
      }
    }
  `,
  filmBigDetail: `
    fragment filmBigDetail on Film {
      hidden
      releaseDate
      synopsisAuthor
      headline
      internationalHeadline
      budgetCurrency
      budget
      productionComment
      AdID
      ISAN
      UPC
      ISRC
      localFilmName
      operationRegionID
      ...filmLocation
      ...critiqueRating
      ...commissionType
      ...filmDetail
      ...filmLocation
      ...operationRegion
    }
  `,
  operationRegion: `
    fragment operationRegion on Film {
      OperationRegion {
        id
        OperationRegionLocalized {
          name
        }
      }
    }
  `,
  filmLocation: `
    fragment filmLocation on Film {
      Location {
        ...locationTree
      }
    }
  `,
  location: `
    fragment location on Location {
      id
      name
    }
  `,
  locationTree: `
    fragment locationTree on Location {
      ...location
      Parent {
        ...location
        Parent {
          ...location
          Parent {
            ...location
          }
        }
      }
    }
  `,
  critiqueRating: `
    fragment critiqueRating on Film {
      CritiqueRating {
        id
        CritiqueRatingLocalized {
          id
          name
        }
      }
    }
  `,
  commissionType: `
    fragment commissionType on Film {
      CommissionType {
        id
        FilmCommissionTypeLocalized {
          id
          name
        }
      }
    }
  `,
  productFilms: `
    fragment productFilms on Product {
      ProductToFilms {
        id
        Film {
          ...filmDetail
          ...filmMasters
          ...filmBigAwards
        }
      }
    }
  `,
  productCompanies: `
    fragment productCompanies on Product {
      ProductToCompanies {
        id
        CompanyToProductRelationshipType {
          RelationshipType {
            ...relationshipTypeDetail
          }
        }
        Company {
          ...companyDetail
          ...companyArtworks
        }
      }
    }
  `,
  productBrands: `
    fragment productBrands on Product {
      ProductToBrands {
        id
        Brand {
          ...brandDetail
          ...brandArtworks
        }
      }
    }
  `,
  productBigDetail: `
    fragment productBigDetail on Product {
      ProductToSlogans {
        id
        international
        slogan
      }
      productCategoryID
      ProductCategory {
      ...productCategoryTree
      }
    }
  `,
  brandFilms: `
    fragment brandFilms on Brand {
      BrandToFilms {
        id
        Film {
          ...filmDetail
          ...filmMasters
          ...filmBigAwards
        }
      }
    }
  `,
  brandBigDetail: `
    fragment brandBigDetail on Brand {
      BrandToSlogans {
        id
        international
        slogan
      }
      productCategoryID
      ProductCategory {
        ...productCategoryTree
      }
    }
  `,
  // note the aliasing of the id
  // for some reason this is non standard in the database, so this just fixes it up to avoid complexities elsewhere
  relationshipTypeDetail: `
    fragment relationshipTypeDetail on RelationshipType {
      id: relationshipTypeID
      itemOrder
      RelationshipTypeLocalized {
        id: relationshipTypeID
        name
      }
    }
  `,
  brandCompanies: `
    fragment brandCompanies on Brand {
      BrandToCompanies {
        id
        CompanyToBrandRelationshipType {
          RelationshipType {
            ...relationshipTypeDetail
          }
        }
        Company {
          ...companyDetail
          ...companyArtworks
        }
      }
    }
  `,
  brandProducts: `
    fragment brandProducts on Brand {
      BrandToProducts {
        id
        Product {
          ...productDetail
          ...productArtworks
        }
      }
    }
  `,
  disResultDetail: `
    fragment disResultDetail on FilmDisambigHit {
      filmID
      score
      Film {
        ...filmDetail
        ...filmMasters
        ...filmAwards
      }
    }
  `,
  dupCheckResultDetail: `
    fragment dupCheckResultDetail on DupCheckResult {
      id
      targetID
      valueKey
      tableName
      type
      idKey
      Accepts {
        id
      }
      Rejects {
        id
      }
    }
  `
};
